import React, { useEffect, useRef, useState } from "react";
import {
  getEnableUsersCount,
  getEnableUsers,
  requestAcceptProjectCapacity,
  requestRejectProjectCapacity,
} from "../../apis/SettingApis";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import {
  Checkbox,
  Form,
  Spin,
} from "antd";
import {
  daysOfWeek,
  UPDATE_ASSIGNING_PAGE,
} from "../../utils/constants";
import { useSelector } from "react-redux";
import { Paginator } from "primereact/paginator";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import UpdateProjectCapacityDialog from "./dialog/UpdateProjectCapacityDialog";
import { updateNumRequestChange } from "../../utils/userUtils";
const ProjectCapacity = () => {
  const [users, setUsers] = useState([]);
  const [requestedChangeUsers, setRequestedChangeUsers] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [visibleProjectCapacityDialog, setVisibleProjectCapacityDialog] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [basicFirst, setBasicFirst] = useState(0);
  const [totalRows, setTotalRows] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [totalRecords, setTotalRecords] = useState();
  const [showRequestedChange, setShowRequestedChange] = useState(false);

  const { currentUser = {} } = useSelector(({ app }) => app);
  const dt = useRef(null);
  const toast = useRef(null);

  const fetchPermissions = () => {
    const uniquePermissions = {};
    if (currentUser && currentUser.roles) {
      currentUser.roles.forEach((role) => {
        role.permissions.forEach(
          (permission) => (uniquePermissions[permission.id] = permission)
        );
      });
      setPermissions(Object.values(uniquePermissions));
    }
  };

  const changeVisibleProjectCapacityDialog = (visible) => {
    setVisibleProjectCapacityDialog(visible);
    fetchUsers(pageNumber, totalRows);
  }

  useEffect(() => {
    fetchPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const fetchUserCount = () => {
    if (pageNumber >= 0 && totalRows >= 10) {
      setApiLoading(true);
      getEnableUsersCount()
        .then((res) => {
          if (res.status === 200) {
            setTotalRecords(res.data);
            fetchUsers(pageNumber, totalRows);
            setApiLoading(false);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Status",
              detail: res.response.data,
              life: 3000,
            });
            setApiLoading(false);
          }
        })
        .catch((e) => {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: e,
            life: 3000,
          });
          setApiLoading(false);
        });
    }
  };

  const acceptProjectCapacity = (userId, requestType) => {
    setApiLoading(true);
    requestAcceptProjectCapacity(userId, requestType)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers(pageNumber, totalRows);
          setApiLoading(false);

          updateNumRequestChange(currentUser, -1);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });

  };

    const rejectProjectCapacity = (userId, requestType) => {
    setApiLoading(true);
    requestRejectProjectCapacity(userId, requestType)
      .then((res) => {
        if (res.status === 200) {
          fetchUsers(pageNumber, totalRows);
          updateNumRequestChange(currentUser, -1);
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });

  };

  const fetchUsers = (current, pageSize) => {
    setApiLoading(true);
    getEnableUsers(current, pageSize)
      .then((response) => {
        if (response.status === 200) {
          response.data = response.data.sort((u1, u2) => {
            return u1.username.localeCompare(u2.username);
          });
          setUsers(response.data);
          setApiLoading(false);
          fetchUsersWithRequestChanges(pageNumber, totalRecords);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
    return false;
  };

  const fetchUsersWithRequestChanges = (current, pageSize) => {
    setApiLoading(true);
    getEnableUsers(current, pageSize)
      .then((response) => {
        if (response.status === 200) {
          response.data = response.data.sort((u1, u2) => {
            return u1.username.localeCompare(u2.username);
          });
          setRequestedChangeUsers(response.data.filter(user => user.capacityRequestStatus === "REQUESTED" || user.requestedDayOffs?.length > 0));
          setApiLoading(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: response.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
    return false;
  };

  useEffect(() => {
  }, []);

  useEffect(() => {
    fetchUserCount();
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pageNumber, totalRows]);

  const onBasicPageChange = (event) => {
    setApiLoading(true);
    setBasicFirst(event.first);
    setPageNumber(event.page);
    setTotalRows(event.rows);
    setApiLoading(false);
  };

  const COLORS = {
    monday: "#FFF0F5",    // Light red
    tuesday: "#F5FFFA",   // Light green
    wednesday: "#F0F8FF", // Light blue
    thursday: "#F0FFF0",  // Light yellow
    friday: "#FFF5EE",    // Light gray
    saturday: "#FFFFE0",     // Light gray
    sunday: "#E5F3FD"     // Light gray
  };

  const headerGroup = (
    <ColumnGroup>
      <Row>
        <Column header="Id" rowSpan={2} />
        <Column header="Username" rowSpan={2} />
        <Column header="Name" rowSpan={2} />
        <Column header="Can Autocad" rowSpan={2} />
        <Column header="Contractor Level" rowSpan={2} />
        <Column header="Qcer/ FCer Level" rowSpan={2} />
        <Column header="Unavailable Days" rowSpan={2} />
        <Column header="Monday" colSpan={3} />
        <Column header="Tuesday" colSpan={3} />
        <Column header="Wednesday" colSpan={3} />
        <Column header="Thursday" colSpan={3} />
        <Column header="Friday" colSpan={3} />
        <Column header="Saturday" colSpan={3} />
        <Column header="Sunday" colSpan={3} />

        <Column header="Action" rowSpan={2}/>
      </Row>

      <Row>
        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />

        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />

        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />

        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />

        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />

        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />

        <Column header="Contractor" />
        <Column header="Qcer" />
        <Column header="FCer" />
      </Row>
    </ColumnGroup>
  );

  const roles = [
    { key: "ContractorCapacity", header: "Contractor" },
    { key: "QcerCapacity", header: "Qcer" },
    { key: "FinalCheckerCapacity", header: "FCer" }
  ];

  const renderCapacityChange = (day, roleKey) => (rowData) => {
    const original =
      rowData.capacityDto?.[`${day.toLowerCase()}${roleKey}`];

    if(rowData.capacityRequestStatus !== "REQUESTED"){
      return <span>{original}</span>;
    }
    const reqKey =
      `req${day}${roleKey}`;

    const requested =
      rowData.capacityDto?.[reqKey];

    if (requested != null && requested !== original) {
      return (
        <span>
          {original}
          {" → "}
          <span style={{ color: "red", fontWeight: 600 }}>
            {requested}
          </span>
        </span>
      );
    }

    return <span>{original}</span>;
  };

  const updateShowRequestedChange = (e) => {
    setShowRequestedChange(e.target.checked);
  };

  return (
    <React.Fragment>
      <div className="user-custom-style">
        <Toast ref={toast} />

        <div>
          <Spin spinning={apiLoading}>
            <Toolbar
              className="mb-4"
              left={() => {
                return (
                  <React.Fragment>
                    <div>
                      <h3 className="m-0">Users</h3>
                    </div>
                  </React.Fragment>
                );
              }}
              right={() => {
                return (
                  <React.Fragment>
                    <Form
                      className="custom-form-design"
                    >
                      <Form.Item
                        name="showRequestedChange"
                        label="Show Requested Change"
                        valuePropName="checked"
                      >
                        <Checkbox onChange={updateShowRequestedChange} />
                      </Form.Item>
                    </Form>
                  </React.Fragment>
                );
              }}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={showRequestedChange ? requestedChangeUsers : users}
              dataKey="id"
              responsiveLayout="scroll"
              headerColumnGroup={headerGroup}
            >
              <Column field="id" header="ID" />
              <Column field="username" header="Username" />
              <Column field="name" header="Name" />
              <Column
                field="canHandleAutoCad"
                header="AutoCad"
                body={(rowData) => rowData?.canHandleAutocad ? (
                  <React.Fragment>
                    <div style={{
                      justifyContent: "center",
                      display: "flex"
                    }}>
                      <div style={{
                        border: "2px solid red",
                        width: "27px",

                      }}>
                        <b>Yes</b>
                      </div>
                    </div>

                  </React.Fragment>
                ) : (
                  <React.Fragment>No</React.Fragment>
                )}
              />
              <Column field="contractorLevel" header="Level/ Type" />
              <Column field="level" header="QCer/ FCer level" />
              <Column
                header="Unavailable Days"
                body={(rowData) => {
                  const original = rowData.dayOffs;
                  const requested = rowData.requestedDayOffs;

                  if (requested && requested !== original) {
                    return (
                      <span>
                        {original}
                        {" → "}
                        <span style={{ color: "red", fontWeight: 600 }}>
                          {requested}
                        </span>
                      </span>
                    );
                  }

                  return original;
                }}
              />
              {daysOfWeek.map((day) =>
                roles.map((role) => (
                  <Column
                    key={`${day}-${role.key}`}
                    header={role.header}
                    style={{ backgroundColor: COLORS[day] }}
                    body={renderCapacityChange(day, role.key)}
                  />
                ))
              )}

              <Column
                field="action"
                header="Action"
                body={(record) => {
                  return (
                    <React.Fragment>
                      <div className="flex justify-content-center">
                        {permissions.map((permission) => {
                          return permission.name === UPDATE_ASSIGNING_PAGE? (
                            <div>
                              {(record.capacityRequestStatus !== "REQUESTED" && record.requestedDayOffs?.length === 0)  &&<Button
                                style={{
                                  backgroundColor: "#037EEA",
                                  borderColor: "#037EEA",
                                }}
                                icon={"pi pi-pencil"}
                                label="Edit"
                                onClick={(event) => {
                                  event.preventDefault();
                                  setSelectedUser(record);
                                  setVisibleProjectCapacityDialog(true);
                                }}
                              />}

                              {record.capacityRequestStatus === "REQUESTED" && 
                              <div style={{ display: "flex", alignItems: "center" }}>
                                <i className="pi pi-sync" style={{ fontSize: "1.1rem", fontWeight: "bold", marginRight: "0.3rem" }} />
                                <Button
                                  title="Accept capacity change"
                                  style={{
                                    backgroundColor: "#037EEA",
                                    borderColor: "#037EEA",
                                    width: "2rem",
                                    height: "2rem"
                                  }}
                                  icon={"pi pi-check "}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setSelectedUser(record);
                                    acceptProjectCapacity(record.id, "CAPACITY");
                                  }}
                                />
                                <Button
                                  title="Reject capacity change"
                                  style={{
                                    margin: "0 0.2rem",
                                    backgroundColor: "red",
                                    borderColor: "red",
                                    width: "2rem",
                                    height: "2rem"
                                  }}
                                  icon={"pi pi-times"}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setSelectedUser(record);
                                    rejectProjectCapacity(record.id, "CAPACITY");
                                  }}
                                />
                              </div>}
                              {record.requestedDayOffs?.length > 0 &&
                                <div style={{ display: "flex", alignItems: "center" }}>
                                <i className="pi pi-calendar" style={{ fontSize: "1.1rem", fontWeight: "bold", margin: "1rem 0.3rem 0 0" }} />
                                <Button
                                  title="Accept day off change"
                                  style={{
                                    backgroundColor: "#037EEA",
                                    borderColor: "#037EEA",
                                    width: "2rem",
                                    height: "2rem"
                                  }}
                                  icon={"pi pi-check "}
                                  onClick={(event) => {
                                    event.preventDefault();
                                    setSelectedUser(record);
                                    acceptProjectCapacity(record.id, "DAY_OFF");
                                  }}
                                />
                                <Button
                                  title="Reject day off change"
                                  style={{
                                    margin: "0 0.2rem",
                                    backgroundColor: "red",
                                    borderColor: "red",
                                    width: "2rem",
                                    height: "2rem"
                                  }}
                                    icon={"pi pi-times"}
                                    onClick={(event) => {
                                      event.preventDefault();
                                      setSelectedUser(record);
                                      rejectProjectCapacity(record.id, "DAY_OFF");
                                    }}
                                  />
                              </div>}
                            </div>
                          ) : (
                            ""
                          );
                        })}
                      </div>
                    </React.Fragment>
                  );
                }}
              />
            </DataTable>
            <Paginator
              first={basicFirst}
              rows={totalRows}
              totalRecords={totalRecords}
              rowsPerPageOptions={[10, 20, 30]}
              onPageChange={onBasicPageChange}
            ></Paginator>
          </Spin>
        </div>
 
      </div>
      <UpdateProjectCapacityDialog
        user={selectedUser}
        visible={visibleProjectCapacityDialog}
        setVisible={changeVisibleProjectCapacityDialog}>
      </UpdateProjectCapacityDialog>
    </React.Fragment>
  );
};

export default ProjectCapacity;
